import { PolicyPayload } from "@/views/setup/return-policy/types";

export const ORDER_STATUSES = [
    "CREATED",
    "PAYMENT_PENDING",
    "PAYMENT_CONFIRMED",
    "INVENTORY_PENDING",
    "INVENTORY_CONFIRMED",
    "FULFILLMENT_PENDING",
    "READY_TO_SHIP",
    "SHIPPED",
    "OUT_FOR_DELIVERY",
    "DELIVERED",
];

export const FEE_TYPES = ["FLAT", "PERCENTAGE"];
export const SHIPPING_PAYER_OPTIONS = ["SELLER", "CUSTOMER", "PLATFORM"];
export const REFUND_METHOD_OPTIONS = [
    "ORIGINAL_PAYMENT",
    "WALLET",
    "CUSTOMER_CHOICE",
];
export const COD_REFUND_METHOD_OPTIONS = ["BANK_TRANSFER", "WALLET"];

export const DEFAULT_POLICY: PolicyPayload = {
    cancellation: {
        enabled: true,
        windowMinutes: 0,
        allowedBeforeStatuses: ["SHIPPED", "DELIVERED"],
        freeCancellationBeforeStatus: "INVENTORY_CONFIRMED",
        fee: { type: "FLAT", value: 0 },
        codCancellationAllowed: true,
        autoApprove: false,
        autoRefundOnApproval: true,
        reasons: [
            "CHANGED_MIND",
            "FOUND_CHEAPER",
            "ORDERED_BY_MISTAKE",
            "DELIVERY_TOO_SLOW",
            "OTHER",
        ],
    },
    return: {
        enabled: true,
        windowDays: 7,
        returnableItemTypes: ["*"],
        nonReturnableItemTypes: [],
        reasons: [
            "DEFECTIVE",
            "WRONG_ITEM",
            "NOT_AS_DESCRIBED",
            "DAMAGED_IN_TRANSIT",
            "QUALITY_ISSUE",
            "OTHER",
        ],
        requireImages: true,
        minImages: 1,
        returnShippingPaidBy: "SELLER",
        autoApproveBelow: 0,
        restockingFee: { type: "FLAT", value: 0 },
        qualityCheckRequired: false,
        autoApprove: false,
    },
    replacement: {
        enabled: true,
        windowDays: 7,
        reasons: ["DEFECTIVE", "WRONG_ITEM", "DAMAGED_IN_TRANSIT"],
        requireOriginalReturn: true,
        requireImages: true,
        shippingPaidBy: "SELLER",
        maxPerOrder: 1,
        autoApprove: false,
    },
    refund: {
        method: "ORIGINAL_PAYMENT",
        processingDays: 7,
        partialRefundAllowed: true,
        codRefundMethod: "WALLET",
        shippingRefundable: true,
        deductions: { cancellationFee: true, restockingFee: true },
    },
    marketPolicies: [],
};
